//系统内置指标样式3：教师语音综合分析

<template>
    <div class="indicator-container">
        <ListHeader title="教师语音综合分析" />
        <div class="indicator-content">
            <div class="score-box">
                <Score :score="data.score" :max-score="data.maxScore"/>
            </div>
            <div class="divider"></div>
            <div class="text-box">

              {{data.remark}}
            </div>
            <div class="divider"></div>
            <div class="chart-box">
                <div class="gauge-container">
                    <div id="gaugeChart1" class="gauge-item"></div>
                </div>
                <div class="gauge-container">
                    <div id="gaugeChart2" class="gauge-item"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import ListHeader from '@/components/ListHeader.vue';
import Score from './Score.vue';
import * as echarts from 'echarts';
export default {
    name: 'SysStyle3',
    components: {
        ListHeader,
        Score,
    },

  props: {
    data: {
      type: Object,
      default: null
    },
  },
    mounted() {
        this.initGaugeCharts();
        // 监听窗口大小变化，重新调整图表大小
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        // 移除窗口大小变化的监听
        window.removeEventListener('resize', this.handleResize);
        // 销毁图表实例，避免内存泄漏
        if (this.gaugeChart1) {
            this.gaugeChart1.dispose();
        }
        if (this.gaugeChart2) {
            this.gaugeChart2.dispose();
        }
    },
    methods: {
        // 初始化两个仪表盘图表
        initGaugeCharts() {

          var extra=JSON.parse(this.data.extra);
          var score1=extra.fluency_score.toFixed(1);
          var score2=extra.integrity_score.toFixed(1);

            // 初始化普通话流利度仪表盘（mock数据：85）
            this.gaugeChart1 = echarts.init(document.getElementById('gaugeChart1'));
            this.renderGaugeChart(this.gaugeChart1, score1, '普通话流利度','#27A6FF');

            // 初始化普通话发音准确度仪表盘（mock数据：78）
            this.gaugeChart2 = echarts.init(document.getElementById('gaugeChart2'));
            this.renderGaugeChart(this.gaugeChart2, score2, '普通话发音准确度','#27FF8F');
        },

        // 渲染单个仪表盘的方法
        renderGaugeChart(chartInstance, value, name,color) {
            const option = {
                backgroundColor: 'transparent',
                series: [
                    {
                        type: 'gauge',
                        startAngle: 180,
                        endAngle: 0,
                        center: ['50%', '75%'],
                        radius: '100%',
                        min: 0,
                        max: 100,
                        splitNumber: 10,
                        axisLine: {
                            roundCap: true,
                            lineStyle: {
                                width: 10,
                            }
                        },

                        itemStyle: {
                            color: color,
                            shadowColor: 'rgba(0,138,255,0.45)',
                            shadowBlur: 10,
                            shadowOffsetX: 2,
                            shadowOffsetY: 2
                        },
                        progress: {
                            show: true,
                            roundCap: true,
                            width: 10
                        },
                        pointer: {
                            icon: 'path://M12.8,0.7l12,40.1H0.7L12.8,0.7z',
                            length: '12%',
                            width: 15,
                            offsetCenter: [0, '-60%'],
                            itemStyle: {
                                color: 'auto'
                            }
                        },
                        axisTick: {
                            length: 2,
                            lineStyle: {
                                color: 'auto',
                                width: 1
                            }
                        },
                        splitLine: {
                            length: 1,
                            lineStyle: {
                                color: 'auto',
                                width: 1
                            }
                        },
                        axisLabel: {
                            color: '#B0E0FF',
                            fontSize: 14,
                            distance: -40,
                            formatter: function (value) {
                                return value + '';
                            }
                        },
                        title: {
                            offsetCenter: [0, '20%'],
                            fontSize: 16,
                            color: '#fff',
                        },
                        detail: {
                            fontSize: 34,
                            offsetCenter: [0, '-30%'],
                            valueAnimation: true,
                            formatter: '{value}',
                            color: '#fff'
                        },
                        data: [
                            {
                                value: value,
                                name: name,
                            }
                        ]
                    }
                ]
            };

            chartInstance.setOption(option);
        },

        // 处理窗口大小变化
        handleResize() {
            if (this.gaugeChart1) {
                this.gaugeChart1.resize();
            }
            if (this.gaugeChart2) {
                this.gaugeChart2.resize();
            }
        }
    }
}
</script>
<style scoped lang="less">
// 引入通用指标样式
@import '@/assets/css/common-indicator.less';

.indicator-container {

    .indicator-content {

        .text-box {
            width: 800px;
        }

        .chart-box {
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            align-items: center;

            .gauge-container {
                display: flex;
                flex-direction: column;
                align-items: center;
                width: 375px;
                height: 100%;
            }

            .gauge-item {
                width: 100%;
                height: 200px;
            }
        }

    }
}
</style>
